import { make } from 'vuex-pathify'

const state = {
    accepted: false,
}

export default {
    namespaced: true,
    state,
    mutations: { ...make.mutations(state) }
};


// WEBPACK FOOTER //
// ./skins/xkiosk/data/rules.js